import { render, staticRenderFns } from "./pension-solutions-table.vue?vue&type=template&id=57dfc1b7&scoped=true"
import script from "./pension-solutions-table.vue?vue&type=script&lang=js"
export * from "./pension-solutions-table.vue?vue&type=script&lang=js"
import style0 from "./pension-solutions-table.vue?vue&type=style&index=0&id=57dfc1b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57dfc1b7",
  null
  
)

/* custom blocks */
import block0 from "./pension-solutions-table.vue?vue&type=custom&index=0&blockType=i18n&lang=json"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ComparisonTable: require('/home/runner/work/frontpages/frontpages/component-library/src/components/molecules/comparison-tables/comparison-table.vue').default,HButton: require('/home/runner/work/frontpages/frontpages/component-library/src/components/atoms/buttons/h-button.vue').default,InfoAlert: require('/home/runner/work/frontpages/frontpages/component-library/src/components/molecules/alerts/info-alert.vue').default})
